<template>
    <div class="container">
        <div class="jumbotron">
            <img
                src="/logo.jpg"
                width="200"
                height="200"
                class="d-inline-block align-top"
                alt=""
            />

            <p class="lead">Please sign in to continue</p>
            <p>
                <button
                    class="btn btn-primary btn-margin"
                    @click="login('facebook')"
                >
                    Sign in with Facebook
                </button>

                <button
                    class="btn btn-danger btn-margin"
                    @click="login('google')"
                >
                    Sign in with Google
                </button>
            </p>

            <p class="text-muted text-description">
                <small>Or revisit our cool website</small>
            </p>
            <a :href="home">{{ home }}</a>
        </div>
    </div>
</template>

<script>
import { config, auth, response } from 'website-core'

export default {
    data() {
        return {
            home: config.url,
        }
    },
    async created() {
        await auth.init()
    },
    methods: {
        async login(type) {
            const user = await auth.login(type)
            if (!user) {
                response.ResShowErr(
                    'There was an error with your login. Please try again later'
                )
                return
            }

            auth.saveSession(type)
            this.$router.push('/')
            return
        },
    },
}
</script>

<style scoped>
.btn-margin {
    margin-top: 1rem;
    margin-left: 0.5rem;
}

.text-description {
    margin-top: 5rem;
}

/* below is copy from home */

/* Space out content a bit */
body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

/* Everything but the jumbotron gets side spacing for mobile first views */
.header,
.marketing,
.footer {
    padding-right: 1rem;
    padding-left: 1rem;
}

/* Custom page header */
.header {
    padding-bottom: 1rem;
    border-bottom: 0.05rem solid #e5e5e5;
}

/* Make the masthead heading the same height as the navigation */
.header h3 {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 3rem;
}

/* Custom page footer */
.footer {
    padding-top: 1.5rem;
    color: #777;
    border-top: 0.05rem solid #e5e5e5;
}

/* Customize container */
@media (min-width: 48em) {
    .container {
        max-width: 54rem;
    }
}

.container-narrow > hr {
    margin: 2rem 0;
}

/* Main marketing message and sign up button */
.jumbotron {
    text-align: center;
    border-bottom: 0.05rem solid #e5e5e5;
    background-color: #263039;
    color: white;
}

.jumbotron .btn {
    padding: 0.75rem 1.5rem;
    font-size: 1.5rem;
}

/* Supporting marketing content */
.marketing {
    margin: 3rem 0;
}

.marketing p + h4 {
    margin-top: 1.5rem;
}

/* Responsive: Portrait tablets and up */
@media screen and (min-width: 48em) {
    /* Remove the padding we set earlier */
    .header,
    .marketing,
    .footer {
        padding-right: 0;
        padding-left: 0;
    }
    /* Space out the masthead */
    .header {
        margin-bottom: 2rem;
    }
    /* Remove the bottom border on the jumbotron for visual effect */
    .jumbotron {
        border-bottom: 0;
    }
}
</style>